import Button from "./Button"
import { Link } from 'react-router-dom';


const Header = () => {
    return (
        <>
        <div className="">
        <img src="" alt="" />
        <h1 className="text-5xl m-6">MixElixir</h1>
        <div className="">
        <Link to={"/"}><Button btnName={'Home'} /></Link>
        <Link to="/DrinkList"><Button btnName={'Drink List'} /></Link>
        <Link to="/AddRecipe"><Button btnName={'Add your fav recipe'} /></Link>
        </div>
        </div>
        </>
    )
}

export default Header